import { render } from "./Toolbar.vue?vue&type=template&id=2b83b31c"
import script from "./Toolbar.vue?vue&type=script&lang=js"
export * from "./Toolbar.vue?vue&type=script&lang=js"
script.render = render

export default script